export const MS_PER_S = 1000

export const US_PER_MS = 1000

export const NS_PER_US = 1000

export const SECONDS_PER_MINUTE = 60

export const MINUTES_PER_HOUR = 60

export const HOURS_PER_DAY = 24

export const SECONDS_PER_HOUR = SECONDS_PER_MINUTE * MINUTES_PER_HOUR

export const MS_PER_MINUTE = SECONDS_PER_MINUTE * MS_PER_S

export const MS_PER_HOUR = SECONDS_PER_HOUR * MS_PER_S

export const MS_PER_DAY = HOURS_PER_DAY * MS_PER_HOUR
